import {
  SelectComponents,
  TruncateTextWithTooltip,
} from '@frontend/legacy-components';

import { UNASSIGNED_VALUE } from 'modules/common/smartComponents/const';

import { TeamMemberOptionType } from '../TeamMemberSelect';
import { ANYBODY_VALUE } from '../const';
import { CustomAvatar } from './CustomAvatar';

export const Option = ({
  children,
  ...restProps
}: SelectComponents.OptionProps<TeamMemberOptionType, boolean>) => {
  const { label, value } = restProps.data;
  const name =
    value !== UNASSIGNED_VALUE && value !== ANYBODY_VALUE ? label : undefined;
  return (
    <SelectComponents.Option {...restProps}>
      <CustomAvatar
        name={name}
        backgroundColor={restProps.data.avatarColor}
        marginRight={0.5}
      />
      <TruncateTextWithTooltip
        tooltipProps={{ isDisabled: true }}
        text={label}
        fontFamily="inherit"
        lineHeight="inherit"
        fontWeight="inherit"
        fontSize="inherit"
        as="span"
      />
    </SelectComponents.Option>
  );
};
